import { render } from "./article-cate-list.vue?vue&type=template&id=5946658c&scoped=true&ts=true"
import script from "./article-cate-list.vue?vue&type=script&lang=ts"
export * from "./article-cate-list.vue?vue&type=script&lang=ts"

import "./article-cate-list.vue?vue&type=style&index=0&id=5946658c&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5946658c"]])

export default __exports__